"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var LogoModel = function LogoModel(json, lang) {
  var data = [];

  if (json && json.length > 0) {
    for (var i = 0; i < json.length; i++) {
      var logo = json[i]["png_".concat(lang)] || json[i].png_nl || json[i].png_fr || json[i].png_de || json[i].png_en;

      if (logo) {
        data.push({
          logo: logo,
          "default": true,
          color: "",
          type: json[i].type,
          order_weight: json[i].type === "establishment" ? json[i].score + 20 : json[i].type === "enterprise" ? json[i].score + 10 : json[i].score + 5
        });
      }
    }
  }

  var arrayFiltered = data.sort(function (a, b) {
    if (a.order_weight < b.order_weight) return 1;
    if (a.order_weight > b.order_weight) return -1;else {
      return 0;
    }
  });
  return arrayFiltered;
};

var _default = LogoModel;
exports["default"] = _default;